<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-12-04 18:18:58
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-12-29 20:41:47
-->

<template>
  <div class="content" :style="{ height: height }">
    <div class="map-wrap">
      <div
        class="initial-btn"
        :class="{
          mt67:
            !mapTopInfoOptions.hasData ||
            (mapTopInfoOptions.hasData && mapTopInfoOptions.data.length > 0),
        }"
        @click="initialAddress"
      >
        <i class="iconfont icon-chushidingwei"></i>
      </div>
      <div class="map-div" id="mapDiv" ref="mapDiv"></div>
      <!-- 情况一：顶部没有其他数据只有一个显示轨迹按钮，情况二：有数据，且data也有数据 -->
      <MapTopInfo
        :mapTopInfoOptions="mapTopInfoOptions"
        v-if="
          !mapTopInfoOptions.hasData ||
          (mapTopInfoOptions.hasData && mapTopInfoOptions.data.length > 0)
        "
      ></MapTopInfo>
      <MapRightInfo
        :showRightInfo="showRightInfo"
        :showLandDetail="showLandDetail"
        :showTrajectoryDetail="showTrajectoryDetail"
        :showAssignDetail="showAssignDetail"
        :showAssignClockInDetail="showAssignClockInDetail"
        :curPolygonVal="curPolygonVal"
        :curMarkerVal="curMarkerVal"
        :hasMapBottomInfo="mapBottomInfoOptions.hasMapBottomInfo"
        :mapRightInfoOptions="mapRightInfoOptions"
        @fn="handleChangeRightInfo"
      >
        <!-- 地块信息 -->
        <template v-slot:landInfo="{ landInfo }">
          <slot name="landInfo" :landInfo="landInfo"></slot>
        </template>
      </MapRightInfo>
      <MapBottomInfo
        v-if="mapBottomInfoOptions.hasMapBottomInfo"
        :mapBottomInfoOptions="mapBottomInfoOptions"
      ></MapBottomInfo>
    </div>
    <el-dialog
      title=""
      :visible.sync="trajectoryPlay.show"
      :show-close="false"
      width="80%"
    >
      <TrajectoryMap v-if="trajectoryPlay.show"></TrajectoryMap>
    </el-dialog>
  </div>
</template>

<script>
import * as maptalks from "maptalks";
import TalksMap from "@/utils/initMapTalks.js";
import MapTopInfo from "./MapTopInfo";
import MapRightInfo from "./MapRightInfo.vue";
import MapBottomInfo from "./MapBottomInfo.vue";
import TrajectoryMap from "../TrajectoryMap/index.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "LandMap",
  data() {
    return {
      TalksMapDialog: new TalksMap(),
      polygonLayerLand: "", // 地块层
      polygonLayerTrajectory: "", // 轨迹块层
      showRightInfo: false, // 是否显示右侧信息
      showAssignDetail: false, // 是否显示派活信息
      showLandDetail: false, // 是否显示地块的信息
      showTrajectoryDetail: false, // 是否显示轨迹的信息
      showAssignClockInDetail: false, // 是否显示打卡的信息
      curPolygonVal: {}, // 点击某块的数据
      curMarkerVal: {}, //点击某个marker的数据
      coordinate: [116.40385627111833, 39.91450200800121],
    };
  },
  components: {
    MapTopInfo,
    MapRightInfo,
    MapBottomInfo,
    TrajectoryMap,
  },
  props: {
    // 所有的地块
    landList: {
      type: Array,
    },
    // 所有的轨迹块
    trajectoryList: {
      type: Array,
    },
    markerList: {
      type: Array,
    },
    markerInfo: {
      type: Object,
    },
    // 顶部信息配置项
    mapTopInfoOptions: {
      type: Object,
      default: function () {
        return {
          hasAll: false,
          isFilter: false,
          data: [],
        };
      },
    },
    // 右侧信息配置项
    mapRightInfoOptions: {
      type: Object,
      default: function () {
        return {
          landInfoType: "vertical", //地块信息样式：vertical 纵向即一行一列，Horizontal横向即一行多列
          hasLandInfoForLandDetail: true, // 地块信息面板是否有地块信息切卡
          hasWorkInfoForLandDetail: true, // 地块信息面板是否有作业信息切卡
          hasAuditInfoForLandDetail: true, // 地块信息面板是否有审核信息切卡
          hasTrajectoryPlayBtn: true, // 是否有轨迹回放按钮
        };
      },
    },
    // 底部信息配置项
    mapBottomInfoOptions: {
      type: Object,
      default: function () {
        return {
          hasMapBottomInfo: false, // 是否有底部信息
          hasAssignBtn: false, // 是否有派活按钮
          orderId: "", // 订单ID
          workTypeId: "", // 作业类型ID
        };
      },
    },
    height: {
      type: String,
      default: "670px",
    },
  },
  watch: {
    landList: {
      handler: function (n) {
        if (n.length > 0) {
          this.landMapInit(
            this.landList,
            "croplandEdge",
            this.landCallBack,
            "polygonLayerLand"
          );
        } else {
          this.polygonLayerLand.clear();
          // this.$message({
          //   message: "暂无数据",
          //   type: "warning",
          // });
        }
      },
      // immediate: true,
      // deep: true,
    },
    showTrajectoryMulti: {
      handler: function (n) {
        this.showRightInfo = false;
        this.showAssignDetail = false;
        this.showTrajectoryDetail = false;
        this.showLandDetail = false;
        this.showAssignClockInDetail = false;
        // 轨迹数据返回回来进行绘制
        if (n.trajectoryList.length > 0) {
          this.handleShowTrajectory(n.showTrajectory);
        } else {
          if (this.polygonLayerTrajectory) {
            this.polygonLayerTrajectory.clear();
          }
        }
      },
      immediate: true,
    },
    markerList: {
      handler: function (n) {
        if (n.length > 0) {
          this.mapAddMultiMarker(this.markerList);
          this.showAssignClockInDetail = true;
        } else {
          this.showAssignClockInDetail = false;
        }
      },
    },
    markerInfo: {
      handler: function (n) {
        if (n.longitude) {
          this.mapAddMarker(this.markerInfo);
          this.showAssignClockInDetail = true;
        }
      },
    },
  },
  computed: {
    ...mapState("map", {
      showTrajectory: (state) => state.showTrajectory,
      trajectoryPlay: (state) => state.trajectoryPlay,
    }),
    // 监听两个值是否展示轨迹和轨迹数据
    showTrajectoryMulti() {
      const { showTrajectory, trajectoryList } = this;
      return { showTrajectory, trajectoryList };
    },
  },
  created() {
    this.$bus.$on("changeRightInfo", this.handleChangeRightInfo);
  },
  mounted() {
    this.getMapInit();
  },
  destroyed() {
    this.$bus.$off("changeRightInfo");
    this.changeShowTrajectory(false);
  },
  methods: {
    ...mapActions("map", ["changeShowTrajectory"]),
    /**
     * @Description:
     * @Author: yangsibo
     * @Date: 2022-12-29 09:12:20
     * @return {*}
     */
    initialAddress() {
      console.log(this.coordinate);
      this.TalksMapDialog.map.setCenter(this.coordinate);
    },
    /**
     * @descripttion: 地图初始化
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:40:39
     */
    getMapInit() {
      this.TalksMapDialog.init("mapDiv", 16);
      this.polygonLayerLand = new maptalks.VectorLayer("polygon").addTo(
        this.TalksMapDialog.map
      );
      this.polygonLayerTrajectory = new maptalks.VectorLayer(
        "trajectory"
      ).addTo(this.TalksMapDialog.map);
    },
    /**
     * @descripttion:监听切换展示地图右侧信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:37
     * @param {*}
     * @return {*}
     */
    handleChangeRightInfo(data) {
      this.showRightInfo = data.show;
      if (data.name && data.name == "assignDetail") {
        this.showLandDetail = false;
        this.showTrajectoryDetail = false;
        this.showAssignDetail = true;
        this.showAssignClockInDetail = false;
      }
    },
    /**
     * @descripttion: 绘制地块的回调函数
     * @Author: juanjuanhui
     * @Date: 2021-12-02 21:02:49
     */
    landCallBack(e) {
      if (this.showTrajectory) {
        return;
      }
      this.showRightInfo = true;
      this.showAssignDetail = false;
      this.showTrajectoryDetail = false;
      this.showLandDetail = true;
      this.showAssignClockInDetail = false;
      this.curPolygonVal = e.target.val;
    },
    /**
     * @descripttion: 监听是否展示轨迹
     * @Author: juanjuanhui
     * @Date: 2021-12-06 15:00:50
     * @param {*} n
     * @return {*}
     */
    handleShowTrajectory(n) {
      if (n) {
        this.landMapInit(
          this.trajectoryList,
          "blockEdge",
          this.trajectoryCallBack,
          "polygonLayerTrajectory"
        );
      } else {
        if (this.polygonLayerTrajectory) {
          this.polygonLayerTrajectory.clear();
        }
      }
      this.showRightInfo = false;
      this.showAssignDetail = false;
      this.showTrajectoryDetail = false;
      this.showLandDetail = false;
      this.showAssignClockInDetail = false;
    },
    /**
     * @descripttion: 绘制轨迹块的回调函数
     * @Author: juanjuanhui
     * @Date: 2021-12-02 21:04:55
     */
    trajectoryCallBack(e) {
      this.showRightInfo = true;
      this.showAssignDetail = false;
      this.showLandDetail = false;
      this.showTrajectoryDetail = true;
      this.showAssignClockInDetail = false;
      this.curPolygonVal = e.target.val;
    },

    /**
     * @descripttion: 地图绘制地块初始化
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:41:46
     * @param {Array} data 总的数据
     * @param {String} dataName 绘制形状数据，由于返回字段名称不一致，故传参
     * @param {function} callback 回调
     * @return {*}
     */
    landMapInit(data, dataName, callback, polygonLayerName) {
      let polygon, lng, lat;
      if (polygonLayerName == "polygonLayerLand") {
        this.polygonLayerLand.clear();
      }
      if (polygonLayerName == "polygonLayerTrajectory") {
        this.polygonLayerTrajectory.clear();
      }
      if (data.length == 0) {
        lng = 116.177427669;
        lat = 28.861500052;
      } else {
        let temp = JSON.parse(data[0].centroid);
        lng = temp[0];
        lat = temp[1];
      }
      let Coordinate = {
        x: lng,
        y: lat,
      };
      this.coordinate = Coordinate;
      console.log(Coordinate);
      this.TalksMapDialog.map.setCenter(Coordinate);
      this.TalksMapDialog.map.setZoom(16);
      data.forEach((item) => {
        if (typeof item[dataName] == "string") {
          item[dataName] = JSON.parse(item[dataName]);
        }
        let colour = "";
        if (polygonLayerName == "polygonLayerTrajectory") {
          colour = "red";
        } else {
          if (item.colour) {
            colour = item.colour;
          } else if (item.landStatus) {
            switch (item.landStatus) {
              case 2:
                colour = "#ae8b71";
                break;
              case 3:
                colour = "#ff9600";
                break;
              case 5:
                colour = "#007eff";
                break;
              case 6:
                colour = "#1cba33";
                break;
            }
          } else {
            colour = "#fff";
          }
        }

        polygon = new maptalks.Polygon(
          item[dataName],
          {
            visible: true,
            editable: true,
            cursor: "pointer",
            shadowBlur: 0,
            shadowColor: "black",
            draggable: false,
            dragShadow: false, // display a shadow during dragging
            drawOnAxis: null, // force dragging stick on a axis, can be: x, y
            symbol: {
              polygonFill: colour, // 图形覆盖颜色
              polygonOpacity: 0.5, // 图形覆盖区域透明度
              lineColor: colour, // 线条颜色
              lineWidth: 2, // 线条宽度
            },
          },
          {
            properties: {
              landStatus: item.landStatus,
            },
          }
        );

        polygon.val = item;
        polygon.flag = 0;
        polygon.on("click", callback);
        polygon.addTo(this[polygonLayerName]);
      });
    },
    /**
     * @descripttion: 绘制多个marker
     * @Author: juanjuanhui
     * @Date: 2022-04-29 14:47:17
     * @param {*} data
     */
    mapAddMultiMarker(data) {
      this.TalksMapDialog.addMultiMarker(
        data,
        require("@/assets/icon_clock_no.png"),
        this.multiMarkerCallback
      );
    },
    /**
     * @descripttion: 绘制多个marker
     * @Author: juanjuanhui
     * @Date: 2022-04-29 14:47:17
     * @param {*} data
     */
    mapAddMarker(data) {
      let Coordinate = {
        x: Number(data.longitude),
        y: Number(data.latitude),
      };
      this.coordinate = Coordinate;
      this.TalksMapDialog.addMarker(data);
    },
    /**
     * @descripttion: 点击某个marker的回调函数
     * @Author: juanjuanhui
     * @Date: 2022-04-29 14:47:40
     * @param {*} e
     */
    multiMarkerCallback(e) {
      let { target } = e;
      this.showRightInfo = true;
      this.showAssignDetail = false;
      this.showLandDetail = false;
      this.showTrajectoryDetail = false;
      this.showAssignClockInDetail = true;
      this.curMarkerVal = target._symbol[0].val;
      target.updateSymbol({
        markerFile: require("@/assets/icon_clock_on.png"),
        markerWidth: 51,
        markerHeight: 62,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  .map-wrap {
    position: relative;
    height: 100%;
    margin-top: 10px;
    overflow: hidden;
    background-color: #f1f3f8;
    .initial-btn {
      &.mt67 {
        top: 61px;
      }
      position: absolute;
      top: 15px;
      left: 15px;
      z-index: 1;
      cursor: pointer;
      width: 40px;
      height: 40px;
      background: #ffffff;
      border-radius: 5px;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont {
        color: #018388;
        font-size: 24px;
      }
    }
    .map-div {
      width: 100%;
      height: 100%;
    }
  }
  ::v-deep {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0 20px 20px;
    }
  }
}
</style>
